<template>
  <div class="gwp">
    <v-progress-linear v-if="!render" indeterminate color="primary" />
    <v-form v-if="render" ref="form" v-model="valid" class="gwp__form" lazy-validation>
      <gateway-settings-layout
        icon="mdi-cash-fast"
        tint="#f9a825"
        :title="$t('zarinpal')"
        :description="$t('settingZarinpalHint')"
        :active="paymentZarinpalSystem === 'active'"
        :loading="isLoading"
        @toggle="(on) => (paymentZarinpalSystem = on ? 'active' : null)"
        @submit="create"
      >
        <section class="gw-section">
          <div class="gw-section__head">
            <v-icon small color="primary">mdi-connection</v-icon>
            <span class="gw-section__title">{{ $t('settingGatewayConnection') }}</span>
          </div>
          <div class="gw-grid">
            <secret-field v-model="paymentZarinpalApiKey" class="gw-span" :label="$t('API KEY')" />
          </div>
        </section>

        <section class="gw-section">
          <div class="gw-section__head">
            <v-icon small color="primary">mdi-safe</v-icon>
            <span class="gw-section__title">{{ $t('settingGatewayDeposit') }}</span>
            <span class="gw-section__hint">{{ $t('settingGatewayDepositHint') }}</span>
          </div>
          <div class="gw-grid">
            <autocomplete
              v-model="paymentZarinpalBank"
              :title="$t('bank') + '/' + $t('cash')"
              type="allBankCash"
            />
          </div>
        </section>
      </gateway-settings-layout>
    </v-form>
    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : 'primary'"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snakbar = !snakbar">{{ $t('close') }}</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
// Settings copy of partial/zarinpal.vue: script kept as-is (same endpoints
// and $data payload); only imports and the template are new.
  // import aicomplete from '../../components/general/AIcomplete/index'
  import General from '../../../../../../Mixins/general'
  import autocomplete from '../SettingAccountPicker'
import GatewaySettingsLayout from './GatewaySettingsLayout'
import SecretField from './SecretField'
  export default {
    name: 'ZarinpalSettings',
    components: {
    autocomplete,
    GatewaySettingsLayout,
    SecretField,
    },
    mixins: [General],
    data: () => ({
      valid: true,
      apiKey: null,
      paymentZarinpalApiKey: null,
      paymentZarinpalBank: null,
      paymentZarinpalSystem: null,
      paymentZarinpalAccountName: null,
      paymentZarinpalAccountShaba: null,
      paymentZarinpalConfirm: false,
      select: 'zarinpal',
      render: false,
      isLoading: false,
    }),
    watch: {
    },
    activated () {
      this.show()
    },
    beforeMount () {
      this.statusItems = [
        {
          value: 'not_completed',
          text: this.$t('not_completed'),
        },
        {
          value: 'canceled',
          text: this.$t('canceled'),
        },
        {
          value: 'not_completed',
          text: this.$t('not_completed'),
        },
        {
          value: 'unfulfilled',
          text: this.$t('unfulfilled'),
        },
        {
          value: 'fulfilled',
          text: this.$t('fulfilled'),
        },
      ]
    },
    mounted () {
      this.show()
    },
    methods: {
      addPaymentMethod () {
        this.paymentItems.push({
          bank: null,
          value: null,
        })
      },
      remove (index) {
        this.paymentItems.splice(index, 1)
      },
      create () {
        if (!this.$refs.form.validate()) return false
        var app = this
        app.isLoading = true
        app.$axios.post(this.$endpoint + 'setting', this.$data)
          .then(res => {
            app.snakbarText = app.$t('registered')
            app.snakbarColor = 'green'
            app.snakbar = true
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => {
            this.isLoading = false
          })
      },
      show () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'setting/' + 1 + '/edit', {
          params: {
            select: app.select,
          },
        })
          .then(res => {
            app.$nextTick(() => {
              res = res.data
              app.paymentZarinpalApiKey = res.paymentZarinpalApiKey
              app.paymentZarinpalSystem = res.paymentZarinpalSystem
              app.paymentZarinpalBank = res.paymentZarinpalBank
              app.render = true
            })
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      copied () {
        this.snakbarText = this.$t('copied')
        this.snakbarColor = 'blue'
        this.snakbar = true
      },
    },
  }
</script>

<style scoped>
.gwp {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}
.gwp__form {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.gwp__status {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-inline-start: auto;
  height: 22px;
  padding: 0 10px;
  border-radius: 11px;
  font-size: 0.72rem;
  font-weight: 600;
}
.gwp__status .v-icon { color: inherit !important; }
.gwp__status--ok { background: rgba(46, 125, 50, 0.12); color: #2e7d32; }
.gwp__status--wait { background: rgba(216, 27, 96, 0.1); color: #c2185b; }
</style>
